import { render, staticRenderFns } from "./BaseFileList.vue?vue&type=template&id=b063571a&scoped=true"
import script from "./BaseFileList.vue?vue&type=script&lang=ts"
export * from "./BaseFileList.vue?vue&type=script&lang=ts"
import style0 from "./BaseFileList.vue?vue&type=style&index=0&id=b063571a&prod&scoped=true&lang=css"
import style1 from "./BaseFileList.vue?vue&type=style&index=1&id=b063571a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063571a",
  null
  
)

export default component.exports